import { render, staticRenderFns } from "./studies.vue?vue&type=template&id=35084a48&scoped=true&"
import script from "./studies.vue?vue&type=script&lang=js&"
export * from "./studies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35084a48",
  null
  
)

export default component.exports